import userAvatar from '../../utils/userAvatar'
import ProfilePopup from '../profile-popup/index'
import Preact, { Component } from 'preact'
import LazyLoader from '../lazy-loading/LazyLoader'
import globals from '../../utils/globals'

class UserAvatar extends Component {
  constructor (props) {
    super(props)

    this.ref = Preact.createRef()

    this.state = {
      ref: false,
      disablePopup: (window.inSidedData ? window.inSidedData.device !== 'desktop' : false) || props.disablePopup,
      disableLink: props.disableLink
    }

    this.generateUserUrl = this.generateUserUrl.bind(this)
  }

  componentDidMount () {
    this.setState({ ref: true })
  }

  generateUserUrl (user) {
    if (globals('application') === 'control') {
      return `/member/profile?userid=${user.id}`
    }
    return `/members/${user.name.toLowerCase()}-${user.id}`
  }

  render (props, state) {
    const { user, extraClass, showRank, style, openInNewTab } = props
    const { disablePopup, disableLink } = state

    if (user.id) {
      return <div class={'avatar ' + (extraClass || '')} style={Object.assign({ float: 'none' }, style)}>
        <div class='profilepicture qa-profile-picture' ref={r => { this.ref = r }} >
          <a class='default-avatar-link qa-topic-meta-last-user-icon' href={disableLink ? null : user.url ? user.url : this.generateUserUrl(user)} target={openInNewTab ? '_blank' : null}>
            {userAvatar.isDefaultAvatar(user.avatar)
              ? <div class={'default-avatar ' + userAvatar.getAvatarClass(user.id)}>
                {userAvatar.getAvatarInital(user.name)}
              </div>
              : <LazyLoader type='img' src={user.avatar} style={{ width: '100%' }} alt={user.name} /> }
            {showRank && user.rank && user.rank.avatarIconUrl
              ? <div class='profilelabel qa-profile-label'><img src={user.rank.avatarIconUrl} title={user.rank.name} /></div>
              : null}
          </a>
          {
            state.ref && !disablePopup && (
              <ProfilePopup
                hoverControl={this.ref}
                memberId={user.id}
                size={{ width: 400, height: 200 }} />
            )
          }
        </div>
      </div>
    }
    return <div class={'avatar ' + (extraClass || '')} style={Object.assign({ float: 'none' }, style)}>
      <div class='profilepicture qa-profile-picture default-avatar-link qa-topic-meta-last-user-icon default-cursor'>
        <div class={'default-avatar ' + userAvatar.getAvatarClass(user.id)}>
          {userAvatar.getAvatarInital(user.name)}
        </div>
      </div>
    </div>
  }
}

export default UserAvatar
